<template>
  <div class="admin-page mx-2">
    <div class="finance-table my-2">
      <div class="my-table my-2">
        <div class="head">
          <div
            v-for="head_item in heads"
            :key="head_item"
            class="head_item title-blue d-inline-block"
          >
            <div class="inner-item">
              {{ head_item }}
            </div>
          </div>
        </div>

        <div v-if="accounting" class="body-table">
          <div
            v-for="table_row in accounting"
            :key="table_row"
            class="body-row"
          >
            <div v-if="!table_row.seller_accounting_id">
              <div class="head_item item  title-blue d-inline-block">
                <div class="inner-item">
                  {{ jalali_date(table_row.created_at) }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.id }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                  <Etiquette :status="parseInt(table_row.status)"></Etiquette>
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.payable }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.discount }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.delivery_cost }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.golpino_commission }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.seller_income }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
            </div>
            <div v-if="table_row.seller_accounting_id">
              <div class="head_item item d-inline-block">
                <div class="inner-item">
                  {{ jalali_date(table_row.created_at) }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.id }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  {{ table_row.desc }}
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">{{ table_row.value }} تومان</div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div v-if="table_row.status == 1" class="inner-item text-primary">
                  برداشت گلپینو
                </div>
                <div v-if="table_row.status == 0" class="inner-item text-danger">
                  واریز گلپینو
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div class="inner-item">
                  <!-- {{ table_row.id }} -->
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div v-if="table_row.status == 1" class="inner-item">
                  {{ table_row.value }} تومان
                </div>
              </div>
              <div class="head_item item title-blue d-inline-block">
                <div v-if="table_row.status == 0" class="inner-item">
                  {{ table_row.value }} تومان
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Service from "../../../utils/admin-service";
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import Etiquette from "../Order/partials/etiquette.vue";
import jalalim from "jalali-moment";

export default {
  components: {
    Etiquette,
  },
  setup(props, context) {
    // intro
    const heads = ref({
      date: "تاریخ",
      factor_number: "شماره فاکتور",
      ducoment_number: "شماره سند",
      golpino_pay: "واریز گلپینو",
      buyer: "خریدار",
      order_status: "وضعیت سفارش",
      factor_amount: "مبلغ فاکتور",
      discount: "تخفیف",
      delivery_cost: "هزینه ارسال",
      golpino_rate: "کمیسیون گلپینو",
      refinable: "قابل تسویه",
      debt_amount: "بدهکار",
    });
    const data_headers = ref([
      { text: "ردیف", value: "number", align: "center" },
      { text: "تاریخ", value: "date", align: "center" },
      { text: "شماره فاکتور", value: "by", align: "center" },
      { text: "شماره سند", value: "calories", align: "center" },
      { text: "واریز گلپینو ", value: "golpino_pay", align: "center" },
      { text: "خریدار", value: "parties", align: "center" },
      { text: "وضعیت سفارش", value: "title_letter", align: "center" },
      { text: "مبلغ فاکتور", value: "parties", align: "center" },
      { text: "تخفیف", value: "parties", align: "center" },
      { text: "هزینه ارسال", value: "parties", align: "center" },
      { text: "درصد گلپینو", value: "parties", align: "center" },
      { text: "قابل تسویه", value: "parties", align: "center" },
      { text: "بدهکار", value: "parties", align: "center" },
    ]);
    const search_store = ref();
    const testing = ref([]);
    const transactions = ref(null);
    const accounting = ref(null);

    // functions
    const theService = computed(() => {
      return Service(false);
    });
    const the_accounting = computed(() => {
      return accounting.value;
    });
    //
    const isMobile = ref(null);
    const isDesktop = ref(null);
    const my_width = ref(null);
    const handleResize = () => {
      my_width.value = window.innerWidth;
      if (my_width.value > 700) {
        isMobile.value = false;
        isDesktop.value = true;
      } else {
        isMobile.value = true;
        isDesktop.value = false;
      }
    };

    const jalali_date = (this_date) => {
      return jalalim(this_date).locale("fa").format("YYYY/MM/DD");
    };
    // operator
    // mounte
    onMounted(() => {
      console.log(context.root.$route.params.id);
      theService.value.receive(
        "admin/accounting/detail/" + context.root.$route.params.id,
        {},
        (s, d) => {
          if (s == 200) {
            accounting.value = d.data;
            console.log("this is alizoka fucker");
            console.log(accounting.value);
          }
        },
        (s, e) => {}
      );
    });

    // returns
    return {
      heads,
      testing,
      transactions,
      accounting,
      data_headers,
      search_store,
      isMobile,
      isDesktop,
      my_width,
      the_accounting,
      Etiquette,
      jalali_date,
    };
  },
};
</script>

<style lang="scss" scoped>
.finance-table {
  border-radius: 10px;
  font-weight: lighter;
}
.my-table {
  background: #fff;
  border-radius: 10px;
  overflow: auto;
  // border: solid 1px #f7befd;
  box-shadow: 1px 1px 3px #ffc4fe8c;
  .head,
  .body-table {
    text-align: right;
  }
  background: #fff;
  .head {
    background: rgb(235, 235, 235);
  }
  .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
    background: rebeccapurple;
  }
}
.auto-table {
}
.search {
  background: #defffd;
}

.head_item {
  background: #f8fcff;
  text-align: center;
  width: calc(100% / 12);
  border: solid 1px #fff;
  line-height: 1.2;
  font-size: 12px;
  font-weight: bold;
  color: #0531b9;
  min-height: 59px;
  vertical-align: top;
  position: relative;

  &:last-child {
    border-left: solid 1px #fce3ff;
  }
  &.item {
    color: #3f51b5;
    font-weight: 400;
  }
}
.table_item {
  text-align: center;
  width: calc(100% / 12);
  border: solid 1px #f8f8f8;
  line-height: 1.2;
  font-size: 11px;
  min-height: 59px;
  vertical-align: top;
  position: relative;
}
.inner-item {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  width: 90%;
}
</style>